<template>
    <div class="article-edit">
        <div class="title">
            <router-link to="/article/list"
                         tag="span">Article List</router-link>
            <span>|</span>
            <el-button class="edit-btn"
                       type="info"
                       size="mini">{{id?'Edit':'Create'}}</el-button>
        </div>
        <div class="article-content">
            <el-form label-position="top"
                     ref="articleForm"
                     :model="articleForm">
                <el-form-item label="Title:"
                              prop="titleEN"
                              required>
                    <el-input placeholder="1 to 200 characters"
                              v-model="articleForm.titleEN"
                              @click.native="showEditDialog('Title')"></el-input>
                </el-form-item>
                <el-form-item label="Abstract:"
                              prop="abstractEN"
                              required>
                    <el-input placeholder="1 to 500 characters"
                              v-model="articleForm.abstractEN"
                              @click.native="showEditDialog('Abstract')"></el-input>
                </el-form-item>
                <el-form-item label="Cover:"
                              prop="coverUrl"
                              required>
                    <!-- :http-request="httpRequest" -->
                    <el-upload class="upload-demo"
                               action="/v1/api/storage/uploadFile"
                               :headers="headerOption"
                               :show-file-list="false"
                               :on-success="uploadSuccess"
                               drag>
                        <div v-if="isShowTxt">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">Drag image or <em>click here to upload.</em></div>
                        </div>
                        <img v-if="articleForm.coverUrl"
                             class="upload-img"
                             :src="articleForm.coverUrl"
                             alt="">
                    </el-upload>
                </el-form-item>
                <el-form-item label="Status(show or hide)"
                              prop="status"
                              required>
                    <el-switch v-model="articleForm.status"
                               active-value="2"
                               inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="Content:"
                              prop="contentEN"
                              required>
                    <quill-editor v-model="articleForm.contentEN"
                                  :options="quillOption"
                                  @click.native="showEditDialog('Content')"></quill-editor>
                </el-form-item>
                <el-form-item label="Country:"
                              prop="checkedCountry">
                    <el-checkbox :indeterminate="isIndeterminate"
                                 v-model="checkAll"
                                 @change="handleCheckAllChange">All</el-checkbox>
                    <el-checkbox-group v-model="articleForm.checkedCountry"
                                       @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="item in countryList"
                                     :label="item.id"
                                     :key="item.id">{{item.nameEN}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

            </el-form>
        </div>
        <div class="sub-btn">
            <el-button class="subBtn"
                       @click.prevent="updateOrAddBlog"
                       :loading="submitLoading">Submit</el-button>
        </div>
        <el-dialog title="Multi-Language"
                   :close-on-click-modal="false"
                   :visible.sync="editDialogVisible"
                   @close="dialogClose"
                   width="50%">
            <div class="edit-title">{{tag}}</div>
            <el-form :model="dialogForm"
                     :rules="dialogFormRules"
                     label-position="top"
                     ref="dialogForm">
                <!-- :rules="[{required:true,message:tag+' is required'}]" -->
                <el-form-item label="English"
                              prop="ENDia">
                    <template v-if="tag=='Content'">
                        <quill-editor v-model="dialogForm.ENDia"
                                      @change="editorENChange"
                                      :options="quillOption"></quill-editor>
                    </template>
                    <template v-else>
                        <el-input type="textarea"
                                  v-model="dialogForm.ENDia"
                                  :rows=3></el-input>
                    </template>
                </el-form-item>
                <el-form-item label="Chinese"
                              prop="CNDia">
                    <template v-if="tag=='Content'">
                        <quill-editor v-model="dialogForm.CNDia"
                                      @change="editorCNChange"
                                      :options="quillOption"></quill-editor>
                    </template>
                    <template v-else>
                        <el-input type="textarea"
                                  v-model="dialogForm.CNDia"
                                  :rows=3></el-input>
                    </template>
                </el-form-item>
                <el-form-item label="French"
                              prop="FRDia">
                    <template v-if="tag=='Content'">
                        <quill-editor v-model="dialogForm.FRDia"
                                      @change="editorFRChange"
                                      :options="quillOption"></quill-editor>
                    </template>
                    <template v-else>
                        <el-input type="textarea"
                                  v-model="dialogForm.FRDia"
                                  :rows=3></el-input>
                    </template>
                </el-form-item>
                <el-form-item label="Arabic"
                              prop="ARDia">
                    <template v-if="tag=='Content'">
                        <quill-editor v-model="dialogForm.ARDia"
                                      @change="editorARChange"
                                      :options="quillOption"></quill-editor>
                    </template>
                    <template v-else>
                        <el-input type="textarea"
                                  v-model="dialogForm.ARDia"
                                  :rows=3></el-input>
                    </template>
                </el-form-item>
                  <el-form-item label="Urdu"
                              prop="URDia">
                    <template v-if="tag=='Content'">
                        <quill-editor v-model="dialogForm.URDia"
                                      @change="editorURChange"
                                      :options="quillOption"></quill-editor>
                    </template>
                    <template v-else>
                        <el-input type="textarea"
                                  v-model="dialogForm.URDia"
                                  :rows=3></el-input>
                    </template>
                </el-form-item>
            </el-form>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="cancelEdit">Cancel</el-button>
                <el-button type="primary"
                           @click="editDialog">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor"; // 导入quillEditor组件
import api from '@api/cooperation'
import Cookies from 'js-cookie'
// import { imgUrl } from '@config/common';
import quillOption from '@config/quill-config'

export default {
    data () {
        let _this = this
        return {
            id: '',
            // 复选框相关
            isIndeterminate: false,
            checkAll: true,
            countryList: [],
            countryIds: [],

            // 弹框相关
            dialogForm: {
                ENDia: '',
                CNDia: '',
                FRDia: '',
                ARDia: '',
                URDia: '',
            },
            tag: '',
            editDialogVisible: false,

            // 上传组件相关
            isShowTxt: true,

            articleForm: {
                titleEN: '',
                abstractEN: '',
                contentEN: '',
                coverUrl: '',
                status: '0',
                checkedCountry: [],

                titleCN: '',
                abstractCN: '',
                contentCN: '',

                titleFR: '',
                abstractFR: '',
                contentFR: '',

                titleAR: '',
                abstractAR: '',
                contentAR: '',

                titleUR: '',
                abstractUR: '',
                contentUR: '',
            },

            quillOption: quillOption,
            dialogFormRules: {
            },
            submitLoading: false
        }
    },
    mounted () {
        this.id = this.$route.query.id
        this.fetchCountryList()
        if (this.id) {
            this.fetchBlogDetail()
        }
    },
    watch: {
        'tag' (val) {
            if (val == 'Title') {
                this.$set(this.dialogFormRules, 'ENDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 200, message: '1 to 200 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'CNDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 200, message: '1 to 200 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'FRDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 200, message: '1 to 200 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'ARDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 200, message: '1 to 200 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'URDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 200, message: '1 to 200 characters.', trigger: 'blur' }])
            } else if (val == 'Abstract') {
                this.$set(this.dialogFormRules, 'ENDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 500, message: '1 to 500 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'CNDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 500, message: '1 to 500 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'FRDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 500, message: '1 to 500 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'ARDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 500, message: '1 to 500 characters.', trigger: 'blur' }])
                this.$set(this.dialogFormRules, 'URDia', [{ required: true, message: val + ' is required', trigger: 'blur' }, { min: 1, max: 500, message: '1 to 500 characters.', trigger: 'blur' }])
            } else {
                this.$set(this.dialogFormRules, 'ENDia', [{ required: true, message: val + ' is required', trigger: 'change' }])
                this.$set(this.dialogFormRules, 'CNDia', [{ required: true, message: val + ' is required', trigger: 'change' }])
                this.$set(this.dialogFormRules, 'FRDia', [{ required: true, message: val + ' is required', trigger: 'change' }])
                this.$set(this.dialogFormRules, 'ARDia', [{ required: true, message: val + ' is required', trigger: 'change' }])
                this.$set(this.dialogFormRules, 'URDia', [{ required: true, message: val + ' is required', trigger: 'change' }])
            }
        }
    },
    methods: {
        dialogClose () {
            this.$refs.dialogForm.resetFields()
        },
        updateOrAddBlog () {
            if (this.id) {
                this.updateBologById()
            } else {
                this.addBlog()
            }
        },
        async fetchBlogDetail () {
            let params = { blogId: this.id }
            const res = await api.queryBlogDetail(params)
            this.articleForm.titleEN = res.data.titleEN
            this.articleForm.abstractEN = res.data.abstractEN
            this.articleForm.contentEN = res.data.contentEN
            this.articleForm.titleCN = res.data.titleCN
            this.articleForm.abstractCN = res.data.abstractCN
            this.articleForm.contentCN = res.data.contentCN
            this.articleForm.titleFR = res.data.titleFR
            this.articleForm.abstractFR = res.data.abstractFR
            this.articleForm.contentFR = res.data.contentFR
             this.articleForm.titleAR = res.data.titleAR
            this.articleForm.abstractAR = res.data.abstractAR
            this.articleForm.contentAR = res.data.contentAR
            this.articleForm.titleUR = res.data.titleUR
            this.articleForm.abstractUR = res.data.abstractUR
            this.articleForm.contentUR = res.data.contentUR
            this.articleForm.checkedCountry = res.data.countryList
            this.articleForm.status = res.data.status.toString()
            this.articleForm.coverUrl = res.data.coverUrl
            if (this.articleForm.coverUrl !== '') {
                this.isShowTxt = false
            }
            this.isIndeterminate = this.articleForm.checkedCountry.length < this.countryIds.length && this.articleForm.checkedCountry.length !== 0
        },
        async updateBologById () {
            this.$refs.articleForm.validate(async valid => {
                if (valid) {
                    let params = {
                        abstractCN: this.articleForm.abstractCN,
                        abstractEN: this.articleForm.abstractEN,
                        abstractFR: this.articleForm.abstractFR,
                        abstractAR: this.articleForm.abstractAR,
                        abstractUR: this.articleForm.abstractUR,
                        contentEN: this.articleForm.contentEN,
                        contentCN: this.articleForm.contentCN,
                        contentFR: this.articleForm.contentFR,
                        contentAR: this.articleForm.contentAR,
                        contentUR: this.articleForm.contentUR,
                        countryIds: this.articleForm.checkedCountry,
                        status: this.articleForm.status,
                        titleEN: this.articleForm.titleEN,
                        titleCN: this.articleForm.titleCN,
                        titleFR: this.articleForm.titleFR,
                        titleAR: this.articleForm.titleAR,
                        titleUR: this.articleForm.titleUR,
                        id: this.id,
                        coverUrl: this.articleForm.coverUrl
                    }
                    this.submitLoading = true;
                    const res = await api.updateBlog(params)
                    this.submitLoading = false;
                    if (res.success) {
                        this.$message.success('Update blog successfully.')
                        this.$router.push({ name: 'articleList', params: { pageNo: this.$route.query.pageNo } })
                    } else {
                        this.$message.error('Failed to create: something wrong with system, please try again later.')
                    }
                }
            })

        },
        async addBlog () {
            this.$refs.articleForm.validate(async valid => {
                if (valid) {
                    let params = {
                        abstractCN: this.articleForm.abstractCN,
                        abstractEN: this.articleForm.abstractEN,
                        abstractFR: this.articleForm.abstractFR,
                        abstractAR: this.articleForm.abstractAR,
                        abstractUR: this.articleForm.abstractUR,
                        contentEN: this.articleForm.contentEN,
                        contentCN: this.articleForm.contentCN,
                        contentFR: this.articleForm.contentFR,
                        contentAR: this.articleForm.contentAR,
                        contentUR: this.articleForm.contentUR,
                        countryIds: this.articleForm.checkedCountry,
                        status: this.articleForm.status,
                        titleEN: this.articleForm.titleEN,
                        titleCN: this.articleForm.titleCN,
                        titleFR: this.articleForm.titleFR,
                        titleAR: this.articleForm.titleAR,
                        titleUR: this.articleForm.titleUR,
                        coverUrl: this.articleForm.coverUrl
                    }
                    this.submitLoading = true;
                    const res = await api.createBlog(params)
                    this.submitLoading = false;
                    if (res.success) {
                        this.$message.success('Add blog successfully.')
                        this.$router.push('/article/list')
                    } else {
                        this.$message.error('Failed to create: something wrong with system, please try again later.')
                    }
                }
            })


        },
        async fetchCountryList () {
            const res = await api.queryAllCountryList()
            if (res.success == true) {
                this.countryList = res.data
                this.countryIds = this.countryList.map(item => { return item.id })
                if (!this.id) {
                    this.articleForm.checkedCountry = this.countryIds
                }
            }
        },
        handleCheckedCitiesChange (e) {
            this.checkAll = e.length == this.countryIds.length ? true : false
            this.isIndeterminate = e.length < this.countryIds.length && e.length !== 0
        },
        handleCheckAllChange (e) {
            this.articleForm.checkedCountry = e ? this.countryIds : []
            this.isIndeterminate = false
        },
        cancelEdit () {
            this.$refs.dialogForm.resetFields()
            this.dialogForm.CNDia = ''
            this.dialogForm.ENDia = ''
            this.dialogForm.FRDia = ''
            this.dialogForm.ARDia = ''
            this.dialogForm.URDia = ''
            this.editDialogVisible = false
        },
        editDialog () {
            this.$refs.dialogForm.validate(valid => {
                if (valid) {
                    if (this.tag == 'Title') {
                        this.articleForm.titleEN = this.dialogForm.ENDia
                        this.articleForm.titleCN = this.dialogForm.CNDia
                        this.articleForm.titleFR = this.dialogForm.FRDia
                        this.articleForm.titleAR = this.dialogForm.ARDia
                        this.articleForm.titleUR = this.dialogForm.URDia

                    } else if (this.tag == 'Abstract') {
                        this.articleForm.abstractEN = this.dialogForm.ENDia
                        this.articleForm.abstractCN = this.dialogForm.CNDia
                        this.articleForm.abstractFR = this.dialogForm.FRDia
                        this.articleForm.abstractAR = this.dialogForm.ARDia
                        this.articleForm.abstractUR = this.dialogForm.URDia

                    } else {
                        this.articleForm.contentEN = this.dialogForm.ENDia
                        this.articleForm.contentCN = this.dialogForm.CNDia
                        this.articleForm.contentFR = this.dialogForm.FRDia
                        this.articleForm.contentAR = this.dialogForm.ARDia
                        this.articleForm.contentUR = this.dialogForm.URDia
                    }
                    this.editDialogVisible = false
                    this.$refs.dialogForm.resetFields()
                }
            })

        },
        showEditDialog (tag) {
            this.editDialogVisible = true
            this.tag = tag
            this.$nextTick(() => {
                if (this.tag == 'Title') {
                    this.dialogForm.ENDia = this.articleForm.titleEN
                    this.dialogForm.CNDia = this.articleForm.titleCN
                    this.dialogForm.FRDia = this.articleForm.titleFR
                    this.dialogForm.ARDia = this.articleForm.titleAR
                    this.dialogForm.URDia = this.articleForm.titleUR
                } else if (this.tag == 'Abstract') {
                    this.dialogForm.ENDia = this.articleForm.abstractEN
                    this.dialogForm.CNDia = this.articleForm.abstractCN
                    this.dialogForm.FRDia = this.articleForm.abstractFR
                    this.dialogForm.ARDia = this.articleForm.abstractAR
                    this.dialogForm.URDia = this.articleForm.abstractUR
                } else {
                    this.dialogForm.ENDia = this.articleForm.contentEN
                    this.dialogForm.CNDia = this.articleForm.contentCN
                    this.dialogForm.FRDia = this.articleForm.contentFR
                    this.dialogForm.ARDia = this.articleForm.contentAR
                    this.dialogForm.URDia = this.articleForm.contentUR
                }
            })

        },
        // httpRequest (data) {
        //     let _this = this
        //     let reader = new FileReader()
        //     reader.readAsDataURL(data.file)
        //     reader.onload = function (e) {
        //         _this.articleForm.coverUrl = this.result
        //         _this.isShowTxt = false
        //     }
        // },
        uploadSuccess (res, file) {
            this.articleForm.coverUrl = res
            this.isShowTxt = false
        },
        editorENChange (e) {
            if (e.text.length == 1) {
                this.dialogForm.ENDia = ''
            }
            this.$refs.dialogForm.validateField('ENDia')
        },
        editorCNChange (e) {
            if (e.text.length == 1) {
                this.dialogForm.CNDia = ''
            }
            this.$refs.dialogForm.validateField('CNDia')

        },
        editorFRChange (e) {
            if (e.text.length == 1) {
                this.dialogForm.FRDia = ''
            }
            this.$refs.dialogForm.validateField('FRDia')
        },
        editorARChange (e) {
            if (e.text.length == 1) {
                this.dialogForm.ARDia = ''
            }
            this.$refs.dialogForm.validateField('ARDia')
        },
          editorURChange (e) {
            if (e.text.length == 1) {
                this.dialogForm.URDia = ''
            }
            this.$refs.dialogForm.validateField('URDia')
        }
    },
    computed: {
        headerOption () {
            return {
                version: '1.0.0',
                countryCode: 'GH',
                lang: 'en',
                token: Cookies.get('admin_token'),
            }
        }
    }
}
</script>
<style scoped>
.article-edit {
    margin-bottom: 20px;
    margin-top: 50px;
    margin-left: 250px;
}
.title {
    padding: 20px;
    border-bottom: 1px solid #e4e4e4;
}
.article-edit span {
    margin-right: 20px;
}
.article-edit .edit-btn {
    border-radius: 10px;
}
.article-content {
    padding-left: 20px;
    border-bottom: 1px solid #eee;
}
.article-operation {
    display: flex;
    align-items: center;
    color: rgb(70, 162, 255);
}
.article-operation span {
    margin-right: 10px;
}
.pagination {
    margin-left: 250px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 20px;
}
.article-edit >>> .ql-editor {
    height: 200px;
}
.article-content >>> .el-upload__input {
    display: none;
}
.sub-btn {
    padding-left: 20px;
}
.subBtn {
    border: none;
    width: 130px;
    font-size: 22px;
    color: #fff;
    margin-top: 10px;
    background-color: #fe7b00;
    border-radius: 5px;
    box-shadow: 2px 2px 2px #ccc;
    margin-bottom: 20px;
}
.edit-title {
    color: #66b1ff;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
}
.article-edit >>> .el-dialog__header {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #eee;
}
.article-edit >>> .el-dialog__footer {
    text-align: center;
}
.upload-demo {
    position: relative;
}
.upload-img {
    position: absolute;
    left: 0px;
    top: 0px;
    /* width: 100%;
    height: 100%; */
    z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/articleEdit.vue